export var BrandEnum;
(function (BrandEnum) {
    BrandEnum["IMN"] = "IMN";
    BrandEnum["IWB"] = "IWB";
    BrandEnum["IWT"] = "IWT";
    BrandEnum["LI"] = "LI";
    BrandEnum["MA"] = "MA";
    BrandEnum["SL"] = "SL";
})(BrandEnum || (BrandEnum = {}));
export class Brand {
    id;
    enumValue;
    constructor(brandId) {
        this.id = brandId;
        this.enumValue = this.mapToBrandEnum(brandId);
    }
    mapToBrandEnum(brandId) {
        switch (brandId) {
            case 'imn':
                return BrandEnum.IMN;
            case 'iwt':
                return BrandEnum.IWT;
            case 'li':
                return BrandEnum.LI;
            case 'sl':
                return BrandEnum.SL;
            default:
                throw new Error(`BrandId ${brandId} is not supported`);
        }
    }
    getId() {
        return this.id;
    }
    getEnumValue() {
        return this.enumValue;
    }
}
